import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useRef, useEffect, useLayoutEffect } from "react";
import classNames from "classnames";
import styles from "./SlidingButtonGroup.module.scss";
import { makeStyles, RaiseColors, Typography, useTheme } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ButtonGroupProductEnum = /*#__PURE__*/function (ButtonGroupProductEnum) {
  ButtonGroupProductEnum["client"] = "client";
  ButtonGroupProductEnum["broker"] = "broker";
  return ButtonGroupProductEnum;
}({});
var SlidingButtonGroup = function SlidingButtonGroup(_ref) {
  var _windowSize$innerWidt;
  var buttons = _ref.buttons,
    product = _ref.product,
    disabled = _ref.disabled,
    _ref$defaultIndex = _ref.defaultIndex,
    defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
    controlledSelectedIndex = _ref.selectedIndex,
    _ref$tightenLayoutFor = _ref.tightenLayoutForBreakpoint,
    tightenLayoutForBreakpoint = _ref$tightenLayoutFor === void 0 ? null : _ref$tightenLayoutFor;
  // Use controlledSelectedIndex if provided, otherwise fall back to internal state
  var _React$useState = React.useState(controlledSelectedIndex !== undefined ? controlledSelectedIndex : defaultIndex),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedIndex = _React$useState2[0],
    setSelectedIndex = _React$useState2[1];
  var btnContainerRef = useRef(null);
  var theme = useTheme();
  var windowSize = useWindowSize();
  var windowWidth = (_windowSize$innerWidt = windowSize.innerWidth) !== null && _windowSize$innerWidt !== void 0 ? _windowSize$innerWidt : 0;

  // Check if current screen size matches the tighten breakpoint
  var shouldUseTightenedLayout = tightenLayoutForBreakpoint ? windowWidth <= _valuesInstanceProperty(theme.breakpoints)[tightenLayoutForBreakpoint] : false;
  var selectedColor = null;
  if (product === ButtonGroupProductEnum.broker) {
    selectedColor = {
      "--select-button-color": RaiseColors.midnight
    };
  } else if (product === ButtonGroupProductEnum.client) {
    selectedColor = {
      "--select-button-color": RaiseColors.midnight
    };
  }
  var slideBg = function slideBg(n) {
    var _btnContainerRef$curr;
    setSelectedIndex(n);
    var buttons = (_btnContainerRef$curr = btnContainerRef.current) === null || _btnContainerRef$curr === void 0 ? void 0 : _btnContainerRef$curr.querySelectorAll(".".concat(styles.button));
    var currentButton = buttons === null || buttons === void 0 ? void 0 : buttons[n];
    if (btnContainerRef.current && currentButton) {
      var offsetLeft = currentButton.offsetLeft;
      var buttonWidth = currentButton.offsetWidth;
      btnContainerRef.current.style.setProperty("--bg-offset", "".concat(offsetLeft, "px"));
      btnContainerRef.current.style.setProperty("--highlight-width", "".concat(buttonWidth, "px"));
    }
  };
  useLayoutEffect(function () {
    if (controlledSelectedIndex !== undefined && controlledSelectedIndex !== selectedIndex) {
      slideBg(controlledSelectedIndex);
    }
  }, [controlledSelectedIndex, selectedIndex]);
  useEffect(function () {
    // Initial slide on mount - use setTimeout to ensure DOM is ready
    var timeoutId = _setTimeout(function () {
      if (controlledSelectedIndex !== undefined) {
        slideBg(controlledSelectedIndex);
      } else {
        slideBg(selectedIndex);
      }
    }, 0);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, []);
  var useButtonStyles = makeStyles(function (theme) {
    return {
      button: tightenLayoutForBreakpoint ? _defineProperty({}, theme.breakpoints.down(tightenLayoutForBreakpoint), {
        paddingLeft: "8px",
        paddingRight: "8px",
        gap: "8px"
      }) : {
        gap: "10px"
      }
    };
  });
  var buttonStyles = useButtonStyles().button;
  return /*#__PURE__*/_jsx("div", {
    style: _objectSpread({}, selectedColor),
    className: styles.container,
    ref: btnContainerRef,
    children: _mapInstanceProperty(buttons).call(buttons, function (buttonProps, index) {
      return /*#__PURE__*/_jsxs("button", {
        className: classNames(styles.button, buttonStyles),
        onClick: function onClick(e) {
          slideBg(index);
          if (buttonProps.onClick) {
            buttonProps.onClick(e);
          }
        },
        disabled: disabled,
        "data-pendo": buttonProps["data-pendo"],
        children: [buttonProps !== null && buttonProps !== void 0 && buttonProps.leadingIcon ? /*#__PURE__*/_jsx("span", {
          style: {
            color: selectedIndex === index ? RaiseColors.neutral100 : RaiseColors.neutral500
          },
          className: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.leadingIcon
        }) : null, /*#__PURE__*/_jsx(Typography, {
          color: selectedIndex === index ? RaiseColors.neutral100 : RaiseColors.neutral500,
          variant: shouldUseTightenedLayout ? "paragraph_xsmall" : "paragraph_small",
          weight: "medium",
          children: buttonProps.label
        })]
      }, index);
    })
  });
};
export default SlidingButtonGroup;